/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "603a1990314a7112485026701a3ac83d0062f786";
